import { COMPLETED } from '../common/Types';
import firebase from '../firebase/initFirebase';
import { DailyTaskI } from '../interfaces/DailyTaskInterface';
import { GoalI } from '../interfaces/GoalInterface';
import { UserI } from '../store/interfaces/storeStatesInterface';
import { taskRef } from './refs';

export function getListByParentKey(
  ref: firebase.database.Reference,
  parentKey: string,
  parentFieldKey: string,
  callback: Function
) {
  var goalTaskList: GoalI[] = [];
  try {
    ref
      .orderByChild(parentFieldKey)
      .equalTo(parentKey)
      .once('value', (snapshot) => {
        const resData = snapshot.val();
        if (resData) {
          const resDataList = Object.values(resData);
          goalTaskList = resDataList.map((d: any) => d);
        }
        callback({ data: goalTaskList });
      });
  } catch (err) {
    callback({ error: err });
  }
}

export function getByKey(
  ref: firebase.database.Reference,
  key: string,
  callback: Function
) {
  var data: GoalI | DailyTaskI | null;
  try {
    ref.child(key).on('value', function (snapshot) {
      const resData = snapshot.val();
      if (resData) {
        data = resData;
      }
      callback({ data: data });
    });
  } catch (err) {
    callback({ error: err });
  }
}

export function updateByKey(
  ref: firebase.database.Reference,
  key: string,
  payload: GoalI | DailyTaskI | UserI,
  callback: Function
) {
  try {
    ref.child(key).set(payload);
    callback({ data: COMPLETED });
  } catch (err) {
    callback({ error: err });
  }
}

export function removeByKey(
  ref: firebase.database.Reference,
  key: string,
  callback: Function
) {
  try {
    ref.child(key).remove();
    callback({ data: COMPLETED });
  } catch (err) {
    callback({ error: err });
  }
}

export function removeListByParentKey(
  ref: firebase.database.Reference,
  parentKey: string,
  parentFieldKey: string,
  callback: Function
) {
  try {
    ref
      .orderByChild(parentFieldKey)
      .equalTo(parentKey)
      .once('value', (snapshot) => {
        const resData = snapshot.val();
        if (resData) {
          const resDataList = Object.values(resData);
          const goalTaskList = resDataList.map((d: any) => d);
          if (goalTaskList) {
            goalTaskList.map(async (t) => await taskRef.child(t.key).remove());
          }
        }
        callback({ data: COMPLETED });
      });
  } catch (err) {
    callback({ error: err });
  }
}
